import store from "@/store/index";
import { ETypeNotification, INotification } from "../interfaces/i-notification";
import { EventBus } from "@/utils/event-bus";

export const dispatch =
  (fn: any) =>
  async (fnParams = [] as any, message?: string) => {
    const notification: INotification[] = [];
    try {
      const data = await store.dispatch(fn(...fnParams));
      if (message) {
        notification.push({
          type: ETypeNotification.SUCCESS,
          title: "Sucesso",
          message,
        });
      }
      return data;
    } catch (err) {
      (err as string[]).forEach((errorMessage: string) => {
        notification.push({
          type: ETypeNotification.DANGER,
          title: "Erro",
          message: errorMessage,
        });
      });
      throw err;
    } finally {
      notification.forEach((not: INotification) => {
        EventBus.$emit("emmit-notification", not);
      });
    }
  };
